import React from "react";
import { observer, inject } from "mobx-react";
import base64 from "base-64";
import { saveAs } from "file-saver";
import { IoMdCloudDownload, IoMdEye } from "react-icons/io";

import "react-tabs/style/react-tabs.css";

import { Button } from "~/common/components";
import FromTo from "~/common/components/FromTo";
import JournalAutocompleteSelect from "./JournalAutocompleteSelect";
import EmployeeTree from "~/modules/employees/components/EmployeeTree";
import PointsTree from "~/modules/points/components/PointsTree";

@inject(
  "userStore",
  "employeesStore",
  "pointsStore",
  "auditStore",
  "journalsStore"
)
@observer
class RequestForm extends React.Component {
  constructor(props) {
    super(props);

    this.onJournalChange = this.onJournalChange.bind(this);
    this.onGetData = this.onGetData.bind(this);
    this.onGetXcel = this.onGetXcel.bind(this);
    this.setDates = this.setDates.bind(this);
    this.onSelectEmployee = this.onSelectEmployee.bind(this);
    this.onSelectPoint = this.onSelectPoint.bind(this);

    this.state = {
      focusedInput: undefined,
      isLoadingFile: false,
      loadingFileError: false,
    };
  }

  onJournalChange(journal) {
    this.props.journalsStore.changeJournal(journal);
  }

  onGetData() {
    const { journalsStore } = this.props;
    journalsStore.loadPage();
  }

  onGetXcel() {
    this.setState({
      isLoadingFile: true,
      loadingFileError: false,
    });
    const { uid, token } = this.props.userStore;
    const {
      employee,
      point,
      startDate,
      endDate,
      journal,
    } = this.props.journalsStore;
    const from = startDate.toISOString();
    const to = endDate.toISOString();
    const downloadUrl = "../api/v4/journals/searches";
    const options = {
      method: "POST",
      headers: {
        Authorization: `Basic ${base64.encode(`${uid}:${token}`)}`,
        Accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      body: JSON.stringify({
        authors: employee && [employee.id],
        points: point && [point.id],
        journal: journal && journal.id,
        from,
        to,
      }),
    };
    fetch(downloadUrl, options).then(
      (response) => {
        response.blob().then(
          (blob) => {
            saveAs(blob, `${journal.name}.xlsx`);
            this.setState({
              isLoadingFile: false,
            });
          },
          () => {
            this.setState({
              isLoadingFile: false,
              loadingFileError: true,
            });
          }
        );
      },
      () => {
        this.setState({
          isLoadingFile: false,
          loadingFileError: true,
        });
      }
    );
  }

  setDates({ startDate, endDate }) {
    const { journalsStore } = this.props;
    journalsStore.setDates({ startDate, endDate });
  }

  onSelectEmployee(employee) {
    const { journalsStore } = this.props;
    journalsStore.setEmployee(employee);
  }

  onSelectPoint(point) {
    const { journalsStore } = this.props;
    journalsStore.setPoint(point);
  }

  render() {
    const { journalsStore } = this.props;
    const {
      canRequest,
      journal,
      journalsArray,
      startDate,
      selectedEmployeeIds,
      selectedPointIds,
      endDate,
    } = journalsStore;
    const { isLoadingFile, loadingFileError } = this.state;

    return (
      <div className="request-form">
        <div className="buttons">
          <Button
            className={"button inline success"}
            disabled={!canRequest}
            onClick={this.onGetData}
            leftIcon={<IoMdEye />}
            text="View data"
          />
          <Button
            className={"button inline active"}
            disabled={!canRequest || isLoadingFile}
            onClick={this.onGetXcel}
            leftIcon={<IoMdCloudDownload />}
            text="Download"
            isLoading={isLoadingFile}
            isError={loadingFileError}
          />
        </div>
        {
          <JournalAutocompleteSelect
            value={journal}
            options={journalsArray}
            onChange={this.onJournalChange}
          />
        }
        <FromTo
          startDate={startDate}
          endDate={endDate}
          onDatesChange={this.setDates}
        />
        {
          <div className="request-params-holder">
            <EmployeeTree
              onSelect={this.onSelectEmployee}
              selectedIds={selectedEmployeeIds}
            />
            <PointsTree
              onSelect={this.onSelectPoint}
              selectedIds={selectedPointIds}
            />
          </div>
        }
      </div>
    );
  }
}

export default RequestForm;
